import { basename, dirname, join } from 'path'
import { nowISOString, isEqual } from 'webmango-utils'

function toFileName (name) {
  return join(
    dirname(name),
    basename(name).replace(/[^\w|.-]+/g, '_') // replace non-word chars, except - and . with _
  )
}

function toShFileName (name) {
  return toFileName(`${name}_run.sh`)
}

function toInFileName (name) {
  return toFileName(`${name}.in`)
}

function toJobFileNames (name) {
  return {
    shFileName: toShFileName(name),
    inFileName: toInFileName(name)
  }
}

export function addTimestamps (oldValue = {}, newValue = {}) {
  const now = nowISOString()
  const createdAt = oldValue.createdAt || newValue.createdAt
  const modifiedAt = oldValue.modifiedAt || newValue.modifiedAt
  return Object.assign({}, newValue, {
    createdAt: createdAt || now,
    modifiedAt: (!oldValue.id) ? modifiedAt || now : (isEqual(oldValue, newValue) ? (modifiedAt || now) : now)
  })
}

export function fromHHMMSS (value) {
  if (typeof value === 'number') return value || 0
  const [hh = 0, mm = 0, ss = 0] = value.split(':').map(Number)
  return hh * 60 * 60 + mm * 60 + ss
}

export {
  toFileName,
  toShFileName,
  toInFileName,
  toJobFileNames
}



// WEBPACK FOOTER //
// ../webmango-core/utils.js